import References from "../../helpers/Reference"

export const calcBtnLayerBottomPos = ( checked, type, currentPos ) => {
    if ( !checked )
        return 0;

    if (!References.layers.hasOwnProperty(type))
        return currentPos;

    return References.layers[type].controlsHeight;
}